module.exports = __webpack_public_path__ + "media/diners.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/diners.png
// module id = 47
// module chunks = 0